export default __webpack_public_path__ + "static/media/go-card-mobile.d7dc5ac3.png";